import React from "react";
import {
  DataGrid as MuiDataGrid,
  DataGridProps as MuiDataGridProps,
  GridColDef,
  GridRowParams,
} from "@mui/x-data-grid";
import { Paper, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Index";

interface CustomeDataGridProps extends MuiDataGridProps {
  rows: any[];
  columns: GridColDef[];
  navigateToOnRowClick?: (id: string | number) => string;
}

const CustomeDataGrid: React.FC<CustomeDataGridProps> = ({
  navigateToOnRowClick,
  ...props
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const reduxTheme = useSelector((state: RootState) => state.theme);

  // Define colors from reduxTheme with fallbacks
  const headerBackgroundColor =
    reduxTheme.primary_colors?.[500] || theme.palette.primary.main;
  const rowBackgroundColor = reduxTheme.primary_colors?.[900] || "#ffffff";
  const headerTextColor = reduxTheme.primary_colors?.[100] || "#614438";

  return (
    <Paper
      sx={{
        boxShadow: 0,
        "@media (min-width: 1024px)": {
          height: "77vh",
        },
        "@media (max-width: 1023px)": {
          height: "auto",
          "& .MuiDataGrid-scrollbar": {
            display: "none",
            width: "0px",
          },
        },
        "& .MuiDataGrid-root": {
          border: "none",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: "none",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: `${headerBackgroundColor} !important`,
          borderBottom: "none",
          color: reduxTheme.primary_colors?.[100] || "#fff",
        },
        "& .MuiDataGrid-columnHeader": {
          padding: "16px",
          backgroundColor: `${headerBackgroundColor} !important`,
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: headerTextColor,
          fontWeight: "bold",
        },
        "& .MuiDataGrid-row": {
          cursor: "pointer",
          backgroundColor: rowBackgroundColor,
        },
        "& .MuiDataGrid-cell:focus": {
          outline: "none",
        },
        "& .MuiDataGrid-footerContainer": {
          backgroundColor: "#fff",
          justifyContent: "center",
          padding: 1,
        },
      }}
    >
      <MuiDataGrid
        onRowClick={(params: GridRowParams) => {
          if (navigateToOnRowClick) {
            navigate(navigateToOnRowClick(params.row.id));
          }
        }}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        {...props}
      />
    </Paper>
  );
};

export default CustomeDataGrid;
